import { getRestorationZoneDemandForecastJsonData } from "api/dataVisualisation/restorationZone/restorationZoneDemandForecast";
import { Region } from "components/dataVisualization/restorationZone/RegionFilter";
import useRequest, { RequestStatus } from "hooks/useRequest";
import DateFilterModel from "models/filterModels/dateFilterModel";
import { RestorationZoneDemandForecastModel } from "models/restorationZone/restorationZoneDemandForecast";
import { useCallback } from "react";

const useRestorationZoneDemandForecastData = (
  dateFilter: DateFilterModel,
  regionFilter: Region
): {
  fetchData: () => void;
  data: RestorationZoneDemandForecastModel[] | null;
  status: RequestStatus;
} => {
  const {
    data: jsonData,
    status,
    request: fetchRestorationZoneDemandForecastData,
  } = useRequest(getRestorationZoneDemandForecastJsonData);

  const fetchData = useCallback(() => {
    fetchRestorationZoneDemandForecastData(dateFilter, regionFilter);
  }, [dateFilter, regionFilter, fetchRestorationZoneDemandForecastData]);

  return {
    data: jsonData?.data ?? null,
    status,
    fetchData,
  };
};

export default useRestorationZoneDemandForecastData;
